import { render, staticRenderFns } from "./RemoveSecondaryPackagingDisplay.vue?vue&type=template&id=371402d9&scoped=true&"
import script from "./RemoveSecondaryPackagingDisplay.vue?vue&type=script&lang=js&"
export * from "./RemoveSecondaryPackagingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371402d9",
  null
  
)

export default component.exports